import { useEffect, useState } from "react";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, AdminStatCard, EmptyState } from "./admin-ui";

function AdminAnalyticsPage() {
    const [data, setData] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        adminService.analytics().then(setData).catch((error) => setMessage(error.message));
    }, []);

    const stats = data?.stats || {};
    const categories = data?.jobsByCategory || [];
    const statuses = data?.jobsByStatus || [];

    return (
        <>
            <AdminPageHeader title="Analytics" subtitle="Jobs, users, applications, and uploads" />
            {message && <div className="alert alert-info">{message}</div>}
            <div className="twm-dash-b-blocks mb-5">
                <div className="row">
                    <AdminStatCard icon="fa fa-user-plus" className="gradi-1" value={stats.newUsers7Days} label="New Users 7 Days" />
                    <AdminStatCard icon="fa fa-paper-plane" className="gradi-2" value={stats.applications7Days} label="Applications 7 Days" />
                    <AdminStatCard icon="fa fa-clock" className="gradi-3" value={stats.pendingOlderThan24h} label="Pending 24h+" />
                    <AdminStatCard icon="fa fa-upload" className="gradi-4" value={stats.uploads} label="Uploads" />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-4">
                    <AdminPanel title="Jobs By Category" icon="fa fa-chart-pie">
                        <SimpleBars rows={categories} labelKey="category" valueKey="total" />
                    </AdminPanel>
                </div>
                <div className="col-lg-6 mb-4">
                    <AdminPanel title="Jobs By Status" icon="fa fa-chart-bar">
                        <SimpleBars rows={statuses} labelKey="status" valueKey="total" />
                    </AdminPanel>
                </div>
            </div>
        </>
    );
}

function SimpleBars({ rows, labelKey, valueKey }) {
    if (!rows?.length) return <EmptyState text="No analytics data yet." />;
    const max = Math.max(...rows.map((row) => Number(row[valueKey] || 0)), 1);
    return (
        <div>
            {rows.map((row) => (
                <div className="m-b15" key={row[labelKey]}>
                    <div className="d-flex justify-content-between"><strong>{row[labelKey] || "Unknown"}</strong><span>{row[valueKey]}</span></div>
                    <div className="progress" style={{ height: 8 }}>
                        <div className="progress-bar" style={{ width: `${(Number(row[valueKey] || 0) / max) * 100}%` }} />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default AdminAnalyticsPage;
